import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/observable/of';

import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

import * as actionsUi from './qs-checks.actions.ui';
import {
    PageState
} from './qs-checks.reducer';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import {
    GetFunktionsbereichePruefplaeneAdminAction,
    GetPruefplanAdminAction,
    GetPruefplanAntwortAdminAction,
    GetPruefplanAntwortenAdminAction, GetPruefplanPruefaufgabeAdminAction, GetPruefplanPruefaufgabenAdminAction, GetPruefplanPruefchecklisteAdminAction,
    GetPruefplanPruefchecklistenAdminAction,
    GetPruefplanPruefobjektAdminAction,
    GetPruefplanPruefobjekteAdminAction, GetPruefplanRollenControllerAdminAction, GetPruefplanRollenPrueferAdminAction,
    PostPruefAntwortAktualisierenAction, PostPruefaufgabeAktualisierenAction, PostPruefaufgabeEntfernenAction, PostPruefaufgabeHinzufuegenAction, PostPruefaufgabeKopierenAction, PostPruefchecklisteAktualisierenAction, PostPruefchecklisteEntfernenAction, PostPruefchecklisteHinzufuegenAction, PostPruefchecklisteKopierenAction,
    PostPruefobjektAktualisierenAction,
    PostPruefobjektEntfernenAction,
    PostPruefobjektHinzufuegenAction,
    PostPruefobjektKopierenAction,
    PostPruefplanAktualisierenAction, PostPruefplanEntfernenAction,
    PostPruefplanHinzufuegenAction, PostPruefplanKopierenAction, PostPruefplanRolleControllerEntfernenAction, PostPruefplanRollenControllerHinzufuegenAction, PostPruefplanRollenPrueferEntfernenAction, PostPruefplanRollenPrueferEntfernenFehlerAction, PostPruefplanRollenPrueferHinzufuegenAction
} from '../../../client-ngrx/qschecks';
import {
    AKTUELLE_PRUEF_AUFGABE_SETZEN,
    AKTUELLE_PRUEF_CHECKLISTE_SETZEN,
    AKTUELLE_PRUEFPLAN_ANTWORT_SETZEN,
    AKTUELLEN_PRUEFPLAN_SETZEN,
    AktuellenPruefplanSetzenAction, AktuellePruefAufgabeSetzenAction, AktuellePruefChecklisteSetzenAction,
    AktuellePruefplanAntwortSetzenAction,
    AKTUELLES_PRUEFOBJEKT_SETZEN,
    AktuellesPruefobjektSetzenAction, PRUEF_AUFGABE_KOPIEREN, PRUEF_AUFGABE_LOESCHEN, PRUEF_AUFGABE_SPEICHERN, PRUEF_AUFGABEN_LADEN, PRUEF_CHECKLISTE_KOPIEREN, PRUEF_CHECKLISTE_LOESCHEN, PRUEF_CHECKLISTE_SPEICHERN, PRUEF_CHECKLISTEN_LADEN, PruefAufgabeKopierenAction, PruefAufgabeLoeschenAction, PruefAufgabenLadenAction, PruefAufgabeSpeichernAction, PruefChecklisteKopierenAction, PruefChecklisteLoeschenAction, PruefChecklistenLadenAction, PruefChecklisteSpeichernAction,
    PRUEFOBJEKT_KOPIEREN,
    PRUEFOBJEKT_LOESCHEN,
    PRUEFOBJEKT_SPEICHERN, PRUEFOBJEKTE_LADEN, PruefobjekteLadenAction,
    PruefobjektKopierenAction,
    PruefobjektLoeschenAction,
    PruefobjektSpeichernAction, PRUEFPLAENE_LADEN, PruefplaeneLadenAction,
    PRUEFPLAN_ANTWORT_SPEICHERN, PRUEFPLAN_ANTWORTEN_LADEN, PRUEFPLAN_KOPIEREN, PRUEFPLAN_LOESCHEN,
    PRUEFPLAN_SPEICHERN,
    PruefplanAntwortenLadenAction,
    PruefplanAntwortSpeichernAction, PruefplanKopierenAction, PruefplanLoeschenAction,
    PruefplanSpeichernAction, QS_CONTROLLER_ROLLEN_LADEN, QS_PRUEFER_ROLLEN_LADEN, QsControllerRollenLadenAction, QsPrueferRollenLadenAction
} from './qs-checks.actions.ui';
import {getPruefAufgabeAktuell, getPruefAufgabeSelektiert, getPruefChecklisteAktuell, getPruefChecklisteSelektiert, getPruefobjektAktuell, getPruefobjektSelektiert, getPruefplanAktuell, getPruefplanAntwortAktuell, getPruefplanAntwortSelektiert, getPruefplanSelektiert, getQsControllerRollenSelected, getQsPrueferRollen, getQsPrueferRollenSelected} from './qs-checks.selectors';
import {PruefAntwortModelRequest, PruefaufgabeModelRequest, PruefchecklisteModelRequest, PruefobjektModelRequest, PruefplanModelRequest, PruefplanRequest, PruefplanRolleMultiRequest, PruefplanRolleRequest} from '../../../clients/qschecks';
import {UuidService} from '@orga-app/providers/uuid.service';

@Injectable()
export class QsChecksUiEffects {

    @Effect()
    pageReset$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET)
        , map((x) => {
            return new GetFunktionsbereichePruefplaeneAdminAction();
        })
    );

    @Effect()
    aktuellenPruefplan$: Observable<Action> = this.actions$.pipe(
        ofType<AktuellenPruefplanSetzenAction>(AKTUELLEN_PRUEFPLAN_SETZEN)
        , flatMap((x) => {
            return [new GetPruefplanAdminAction(x.payload.pruefplan_id),
            new GetPruefplanPruefobjekteAdminAction(x.payload.pruefplan_id),
            new GetPruefplanPruefchecklistenAdminAction(x.payload.pruefplan_id),
            new GetPruefplanAntwortenAdminAction(x.payload.pruefplan_id),
            new GetPruefplanRollenPrueferAdminAction(x.payload.pruefplan_id),
            new GetPruefplanRollenControllerAdminAction(x.payload.pruefplan_id)];
        })
    );

    @Effect()
    pruefplaeneLaden$: Observable<Action> = this.actions$.pipe(
        ofType<PruefplaeneLadenAction>(PRUEFPLAENE_LADEN)
        , map((x) => {
            return new GetFunktionsbereichePruefplaeneAdminAction();
            })
        );

    @Effect()
    pruefplanSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<PruefplanSpeichernAction>(PRUEFPLAN_SPEICHERN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== null)
        , map(([x, pruefplan]) => {
            const request: PruefplanModelRequest = {
                funktionsbereich_id: pruefplan.funktionsbereich_id,
                pruefplan_id: pruefplan.pruefplan_id,
                beschreibung: pruefplan.beschreibung,
                ist_aktiv: pruefplan.ist_aktiv,
                zaehler_pro_veranstaltungstyp: pruefplan.zaehler_pro_veranstaltungstyp,
                titel: pruefplan.titel,
            };
            if (pruefplan.pruefplan_id !== null && pruefplan.pruefplan_id !== undefined) {
                return new PostPruefplanAktualisierenAction(request);
            } else {
                request.pruefplan_id = this.uuid.generateUUID();
                return new PostPruefplanHinzufuegenAction(request);
            }
        })
    );

    @Effect()
    pruefplanLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<PruefplanLoeschenAction>(PRUEFPLAN_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== null)
        , map(([x, pruefplan]) => {
            const request: PruefplanRequest = {
                pruefplan_id: pruefplan.pruefplan_id,
            };
            return new PostPruefplanEntfernenAction(request);
        })
    );

    @Effect()
    pruefplanKopieren$: Observable<Action> = this.actions$.pipe(
        ofType<PruefplanKopierenAction>(PRUEFPLAN_KOPIEREN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== null)
        , map(([x, pruefplan]) => {
            const request: PruefplanRequest = {
                pruefplan_id: pruefplan.pruefplan_id,
            };
            return new PostPruefplanKopierenAction(request);
        })
    );

    @Effect()
    pruefAntwortenLaden$: Observable<Action> = this.actions$.pipe(
        ofType<PruefplanAntwortenLadenAction>(PRUEFPLAN_ANTWORTEN_LADEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== undefined && pruefplan !== null)
        , map(([x, pruefplan]) => {
            return new GetPruefplanAntwortenAdminAction(pruefplan.pruefplan_id);
        })
    );

    @Effect()
    aktuellePruefplanAntwort$: Observable<Action> = this.actions$.pipe(
        ofType<AktuellePruefplanAntwortSetzenAction>(AKTUELLE_PRUEFPLAN_ANTWORT_SETZEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAntwortSelektiert)))
        , filter(([x, antwort]) => antwort !== null)
        , flatMap(([x, antwort]) => {
            return [new GetPruefplanAntwortAdminAction(antwort.pruefplan_id, antwort.antwort_id)];
        })
    );

    @Effect()
    pruefplanAntwortSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<PruefplanAntwortSpeichernAction>(PRUEFPLAN_ANTWORT_SPEICHERN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAntwortAktuell)))
        , filter(([x, pruefantwort]) => pruefantwort !== null)
        , map(([x, pruefantwort]) => {
            const request: PruefAntwortModelRequest = {
                pruefplan_id: pruefantwort.pruefplan_id,
                antwort_id: pruefantwort.antwort_id,
                beschreibung: pruefantwort.beschreibung,
                ist_aktiv: pruefantwort.ist_aktiv,
                gewichtung: pruefantwort.gewichtung,
                farbe: pruefantwort.farbe,
                icon: pruefantwort.icon,
                ist_na: pruefantwort.ist_na,
                kuerzel: pruefantwort.kuerzel,
            };
            return new PostPruefAntwortAktualisierenAction(request);
        })
    );

    @Effect()
    pruefobjekteLaden$: Observable<Action> = this.actions$.pipe(
        ofType<PruefobjekteLadenAction>(PRUEFOBJEKTE_LADEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== undefined && pruefplan !== null)
        , map(([x, pruefplan]) => {
            return new GetPruefplanPruefobjekteAdminAction(pruefplan.pruefplan_id);
        })
    );

    @Effect()
    aktuellesPruefobjekt$: Observable<Action> = this.actions$.pipe(
        ofType<AktuellesPruefobjektSetzenAction>(AKTUELLES_PRUEFOBJEKT_SETZEN)
        , withLatestFrom(this.store$.pipe(select(getPruefobjektSelektiert)))
        , filter(([x, pruefobjekt]) => pruefobjekt !== null)
        , flatMap(([x, pruefobjekt]) => {
            return [new GetPruefplanPruefobjektAdminAction(pruefobjekt.pruefplan_id, pruefobjekt.pruefobjekt_id)];
        })
    );

    @Effect()
    pruefobjektLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<PruefobjektLoeschenAction>(PRUEFOBJEKT_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getPruefobjektSelektiert)))
        , filter(([x, pruefobjekt]) => pruefobjekt !== null)
        , map(([x, pruefobjekt]) => {
            return new PostPruefobjektEntfernenAction({
                pruefobjekt_id: pruefobjekt.pruefobjekt_id,
                pruefplan_id: pruefobjekt.pruefplan_id,
            });
        })
    );

    @Effect()
    pruefobjektKopieren$: Observable<Action> = this.actions$.pipe(
        ofType<PruefobjektKopierenAction>(PRUEFOBJEKT_KOPIEREN)
        , withLatestFrom(this.store$.pipe(select(getPruefobjektSelektiert)))
        , filter(([x, pruefobjekt]) => pruefobjekt !== null)
        , map(([x, pruefobjekt]) => {
            return new PostPruefobjektKopierenAction({
                pruefobjekt_id: pruefobjekt.pruefobjekt_id,
                pruefplan_id: pruefobjekt.pruefplan_id,
            });
        })
    );

    @Effect()
    pruefobjektSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<PruefobjektSpeichernAction>(PRUEFOBJEKT_SPEICHERN)
        , withLatestFrom(this.store$.pipe(select(getPruefobjektAktuell)))
        , filter(([x, pruefobjekt]) => pruefobjekt !== null)
        , map(([x, pruefobjekt]) => {
            const request: PruefobjektModelRequest = {
                pruefobjekt_id: pruefobjekt.pruefobjekt_id,
                pruefplan_id: pruefobjekt.pruefplan_id,
                beschreibung: pruefobjekt.beschreibung,
                ist_aktiv: pruefobjekt.ist_aktiv,
                titel: pruefobjekt.titel,
            };
            if (pruefobjekt.pruefobjekt_id !== null && pruefobjekt.pruefobjekt_id !== undefined) {
                return new PostPruefobjektAktualisierenAction(request);
            } else {
                request.pruefobjekt_id = this.uuid.generateUUID();
                return new PostPruefobjektHinzufuegenAction(request);
            }
        })
    );

    // Pruef-Checklisten
    @Effect()
    pruefChecklistenLaden$: Observable<Action> = this.actions$.pipe(
        ofType<PruefChecklistenLadenAction>(PRUEF_CHECKLISTEN_LADEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== undefined && pruefplan !== null)
        , map(([x, pruefplan]) => {
            return new GetPruefplanPruefchecklistenAdminAction(pruefplan.pruefplan_id);
        })
    );

    @Effect()
    aktuellesPruefCheckliste$: Observable<Action> = this.actions$.pipe(
        ofType<AktuellePruefChecklisteSetzenAction>(AKTUELLE_PRUEF_CHECKLISTE_SETZEN)
        , withLatestFrom(this.store$.pipe(select(getPruefChecklisteSelektiert)))
        , filter(([x, checkliste]) => checkliste !== null)
        , flatMap(([x, checkliste]) => {
            return [new GetPruefplanPruefchecklisteAdminAction(checkliste.pruefplan_id, checkliste.pruefcheckliste_id),
            new GetPruefplanPruefaufgabenAdminAction(checkliste.pruefplan_id, checkliste.pruefcheckliste_id)];
        })
    );

    @Effect()
    pruefChecklisteLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<PruefChecklisteLoeschenAction>(PRUEF_CHECKLISTE_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getPruefChecklisteSelektiert)))
        , filter(([x, checkliste]) => checkliste !== null)
        , map(([x, checkliste]) => {
            return new PostPruefchecklisteEntfernenAction({
                pruefcheckliste_id: checkliste.pruefcheckliste_id,
                pruefplan_id: checkliste.pruefplan_id,
            });
        })
    );

    @Effect()
    pruefChecklisteKopieren$: Observable<Action> = this.actions$.pipe(
        ofType<PruefChecklisteKopierenAction>(PRUEF_CHECKLISTE_KOPIEREN)
        , withLatestFrom(this.store$.pipe(select(getPruefChecklisteSelektiert)))
        , filter(([x, checkliste]) => checkliste !== null)
        , map(([x, checkliste]) => {
            return new PostPruefchecklisteKopierenAction({
                pruefcheckliste_id: checkliste.pruefcheckliste_id,
                pruefplan_id: checkliste.pruefplan_id,
            });
        })
    );

    @Effect()
    pruefChecklisteSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<PruefChecklisteSpeichernAction>(PRUEF_CHECKLISTE_SPEICHERN)
        , withLatestFrom(this.store$.pipe(select(getPruefChecklisteAktuell)))
        , filter(([x, checkliste]) => checkliste !== null)
        , map(([x, checkliste]) => {
            const request: PruefchecklisteModelRequest = {
                pruefcheckliste_id: checkliste.pruefcheckliste_id,
                pruefplan_id: checkliste.pruefplan_id,
                beschreibung: checkliste.beschreibung,
                ist_aktiv: checkliste.ist_aktiv,
                titel: checkliste.titel,
            };
            if (checkliste.pruefcheckliste_id !== null && checkliste.pruefcheckliste_id !== undefined) {
                return new PostPruefchecklisteAktualisierenAction(request);
            } else {
                request.pruefcheckliste_id = this.uuid.generateUUID();
                return new PostPruefchecklisteHinzufuegenAction(request);
            }
        })
    );

    // Pruef-Aufgaben
    @Effect()
    pruefAufgabenLaden$: Observable<Action> = this.actions$.pipe(
        ofType<PruefAufgabenLadenAction>(PRUEF_AUFGABEN_LADEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanSelektiert)),
            this.store$.pipe(select(getPruefChecklisteSelektiert)))
        , filter(([x, pruefplan, checkliste]) => pruefplan !== undefined && pruefplan !== null
            && checkliste !== undefined && checkliste !== null)
        , map(([x, pruefplan, checkliste]) => {
            return new GetPruefplanPruefaufgabenAdminAction(pruefplan.pruefplan_id, checkliste.pruefcheckliste_id, );
        })
    );

    @Effect()
    aktuellesPruefAufgabe$: Observable<Action> = this.actions$.pipe(
        ofType<AktuellePruefAufgabeSetzenAction>(AKTUELLE_PRUEF_AUFGABE_SETZEN)
        , withLatestFrom(this.store$.pipe(select(getPruefAufgabeSelektiert)))
        , filter(([x, aufgabe]) => aufgabe !== null)
        , flatMap(([x, aufgabe]) => {
            return [new GetPruefplanPruefaufgabeAdminAction(aufgabe.pruefplan_id, aufgabe.pruefcheckliste_id, aufgabe.pruefaufgabe_id)];
        })
    );

    @Effect()
    pruefAufgabeLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<PruefAufgabeLoeschenAction>(PRUEF_AUFGABE_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getPruefAufgabeSelektiert)))
        , filter(([x, aufgabe]) => aufgabe !== null)
        , map(([x, aufgabe]) => {
            return new PostPruefaufgabeEntfernenAction({
                pruefaufgabe_id: aufgabe.pruefaufgabe_id,
                pruefcheckliste_id: aufgabe.pruefcheckliste_id,
                pruefplan_id: aufgabe.pruefplan_id,
            });
        })
    );

    @Effect()
    pruefAufgabeKopieren$: Observable<Action> = this.actions$.pipe(
        ofType<PruefAufgabeKopierenAction>(PRUEF_AUFGABE_KOPIEREN)
        , withLatestFrom(this.store$.pipe(select(getPruefAufgabeSelektiert)))
        , filter(([x, aufgabe]) => aufgabe !== null)
        , map(([x, aufgabe]) => {
            return new PostPruefaufgabeKopierenAction({
                pruefaufgabe_id: aufgabe.pruefaufgabe_id,
                pruefcheckliste_id: aufgabe.pruefcheckliste_id,
                pruefplan_id: aufgabe.pruefplan_id,
            });
        })
    );

    @Effect()
    pruefAufgabeSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<PruefAufgabeSpeichernAction>(PRUEF_AUFGABE_SPEICHERN)
        , withLatestFrom(this.store$.pipe(select(getPruefAufgabeAktuell)))
        , filter(([x, aufgabe]) => aufgabe !== null)
        , map(([x, aufgabe]) => {
            // console.log('Aufgabe: ', aufgabe);
            let zulaessigeAntwortIds: Array<string> = [];
            if (aufgabe.zulaessige_antworten !== undefined && aufgabe.zulaessige_antworten !== null) {
                zulaessigeAntwortIds = aufgabe.zulaessige_antworten.filter(antwort => antwort.ist_aktiv)
                    .map((antwort) => antwort.pruefantwort.antwort_id);
            }
            const request: PruefaufgabeModelRequest = {
                pruefaufgabe_id: aufgabe.pruefaufgabe_id,
                pruefcheckliste_id: aufgabe.pruefcheckliste_id,
                pruefplan_id: aufgabe.pruefplan_id,
                beschreibung: aufgabe.beschreibung,
                gewichtung: aufgabe.gewichtung,
                zulaessige_antwort_ids: zulaessigeAntwortIds,
                ist_aktiv: aufgabe.ist_aktiv,
                titel: aufgabe.titel,
            };
            if (aufgabe.pruefaufgabe_id !== null && aufgabe.pruefaufgabe_id !== undefined) {
                return new PostPruefaufgabeAktualisierenAction(request);
            } else {
                request.pruefaufgabe_id = this.uuid.generateUUID();
                return new PostPruefaufgabeHinzufuegenAction(request);
            }
        })
    );

    // Berechtigungen
    @Effect()
    qsPrueferLaden$: Observable<Action> = this.actions$.pipe(
        ofType<QsPrueferRollenLadenAction>(QS_PRUEFER_ROLLEN_LADEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== undefined && pruefplan !== null)
        , map(([x, pruefplan]) => {
            return new GetPruefplanRollenPrueferAdminAction(pruefplan.pruefplan_id);
        })
    );

    @Effect()
    prueferRollenLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.QsPrueferRollenLoeschenAction>(actionsUi.QS_PRUEFER_ROLLEN_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getQsPrueferRollenSelected)),
            this.store$.pipe(select(getPruefplanSelektiert)))
        , flatMap(([x, prueferRollenSelected, aktuellerPruefplan]) => {
            const actions = [];
            prueferRollenSelected.forEach(rolleId => {
                const request = <PruefplanRolleRequest>{
                    pruefplan_id: aktuellerPruefplan.pruefplan_id,
                    rolle_id: rolleId,
                    zeitpunkt_utc: new Date()
                };
                actions.push(new PostPruefplanRollenPrueferEntfernenAction(request));
            });

            return actions;
        }));

    @Effect()
    prueferRollenHinzufuegen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.QsPrueferRollenHinzufuegenAction>(actionsUi.QS_PRUEFER_ROLLEN_HINZUFUEGEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanSelektiert)))
        , map(([x, aktuellerPruefplan]) => {
            const request = <PruefplanRolleMultiRequest>{
                pruefplan_id: aktuellerPruefplan.pruefplan_id,
                rolle_ids: x.payload,
                zeitpunkt_utc: new Date()
            };
            return new PostPruefplanRollenPrueferHinzufuegenAction(request);
        }));

    @Effect()
    qsControllerLaden$: Observable<Action> = this.actions$.pipe(
        ofType<QsControllerRollenLadenAction>(QS_CONTROLLER_ROLLEN_LADEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanAktuell)))
        , filter(([x, pruefplan]) => pruefplan !== undefined && pruefplan !== null)
        , map(([x, pruefplan]) => {
            return new GetPruefplanRollenControllerAdminAction(pruefplan.pruefplan_id);
        })
    );

    @Effect()
    controllerRollenLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.QsControllerRollenLoeschenAction>(actionsUi.QS_CONTROLLER_ROLLEN_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getQsControllerRollenSelected)),
            this.store$.pipe(select(getPruefplanSelektiert)))
        , flatMap(([x, rollenSelected, aktuellerPruefplan]) => {
            const actions = [];
            rollenSelected.forEach(rolleId => {
                const request = <PruefplanRolleRequest>{
                    pruefplan_id: aktuellerPruefplan.pruefplan_id,
                    rolle_id: rolleId,
                    zeitpunkt_utc: new Date()
                };
                actions.push(new PostPruefplanRolleControllerEntfernenAction(request));
            });

            return actions;
        }));

    @Effect()
    controllerRollenHinzufuegen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.QsControllerRollenHinzufuegenAction>(actionsUi.QS_CONTROLLER_ROLLEN_HINZUFUEGEN)
        , withLatestFrom(this.store$.pipe(select(getPruefplanSelektiert)))
        , map(([x, aktuellerPruefplan]) => {
            const request = <PruefplanRolleMultiRequest>{
                pruefplan_id: aktuellerPruefplan.pruefplan_id,
                rolle_ids: x.payload,
                zeitpunkt_utc: new Date()
            };
            return new PostPruefplanRollenControllerHinzufuegenAction(request);
        }));

    constructor(private actions$: Actions,
                private uuid: UuidService,
                private store$: Store<PageState>) {
    }
}
